import { ReactElement } from 'react';
import { Table, TableColumn, ValidationContainer } from './styles';
import { getMonthsGuideValues, renderHeaders } from '../PreFillGuide/helpers';
import { ApiResps } from '~/providers';

type ValidatedList = ApiResps['/energy/check-goals-batch']['LIST'];

interface ValidationTableProps {
  validatedList: ValidatedList;
}

const columns = [
  { key: 'UNIT_NAME', label: 'Unidade' },
  { key: 'UNIT_ID', label: 'Unidade' },
  { key: 'YEAR', label: 'Ano' },
  { key: 'GOAL_KWH_JAN', label: 'Meta kWh Jan', dependsOnGoals: true },
  { key: 'GOAL_KWH_FEB', label: 'Meta kWh Fev', dependsOnGoals: true },
  { key: 'GOAL_KWH_MAR', label: 'Meta kWh Mar', dependsOnGoals: true },
  { key: 'GOAL_KWH_APR', label: 'Meta kWh Abr', dependsOnGoals: true },
  { key: 'GOAL_KWH_MAY', label: 'Meta kWh Mai', dependsOnGoals: true },
  { key: 'GOAL_KWH_JUN', label: 'Meta kWh Jun', dependsOnGoals: true },
  { key: 'GOAL_KWH_JUL', label: 'Meta kWh Jul', dependsOnGoals: true },
  { key: 'GOAL_KWH_AGO', label: 'Meta kWh Ago', dependsOnGoals: true },
  { key: 'GOAL_KWH_SEP', label: 'Meta kWh Set', dependsOnGoals: true },
  { key: 'GOAL_KWH_OCT', label: 'Meta kWh Out', dependsOnGoals: true },
  { key: 'GOAL_KWH_NOV', label: 'Meta kWh Nov', dependsOnGoals: true },
  { key: 'GOAL_KWH_DEC', label: 'Meta kWh Dez', dependsOnGoals: true },
];

export function ValidationTable({
  validatedList,
}: Readonly<ValidationTableProps>): ReactElement {
  const monthValues = getMonthsGuideValues();

  const headers = [
    'Unidade',
    'Id da Unidade',
    'Ano',
  ];

  function renderValidatedRow(row: ValidatedList[number]): ReactElement {
    const { ERRORS, ...values } = row;

    const errorColumns = new Set(ERRORS.map((item) => item.COLUMN));

    function verifyHasError(column: string): boolean {
      return errorColumns.has(column);
    }

    const goalsError = verifyHasError('GOALS');

    return (
      <tr key={`validated-row-${values.UNIT_ID}-${values.UNIT_NAME}`}>
        {columns.map(({ key, label, dependsOnGoals }) => (
          <TableColumn
            key={key}
            error={verifyHasError(label) || (dependsOnGoals && goalsError)}
          >
            {values[key as keyof typeof values]}
          </TableColumn>
        ))}
      </tr>
    );
  }

  return (
    <ValidationContainer>
      <Table>
        {renderHeaders(headers, monthValues.headers)}
        <tbody>
          {validatedList.map((item) => renderValidatedRow(item))}
        </tbody>
      </Table>
    </ValidationContainer>
  );
}
